import React from 'react';

export const SearchResults = ({ type, results }) => {
  const items = []
  results.items.forEach(item => {
    // console.log('Item data:', item);

    const document = item.publication_file || item.document
    let datestring
    if (item.publish_date) {
      const date = new Date(item.publish_date.timestamp * 1000)

      datestring = date.getDate().toString()+' '+[
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ][date.getMonth()]+' '+date.getFullYear().toString()
    }
    const tags = item.tags
    const knownExtensions = ['pdf', 'doc', 'docx', 'xlsx', 'csv', 'xls'];
    const ext = item.title.split('.').pop().toLowerCase();
    const hasExtension = knownExtensions.includes(ext);

    const displayTitle = type === 'document' && item.title.includes('.') && hasExtension
      ? item.title.substring(0, item.title.lastIndexOf('.'))
      : item.title

    items.push(<div key={item.id} className="nsw-list-item p-4 border rounded">
      {item.preview_image?.url && <div className="nsw-list-item__image" data-type={type}>
        <img src={item.preview_image.url} alt={item.preview_image.alt} />
      </div>}
      <div className="nsw-list-item__content">
        <h3 className="nsw-list-item__title">
          {item.url ? <a href={item.url}>{displayTitle}</a> : displayTitle}
        </h3>
        {(datestring || document || item.short_description || tags.length) ? <div className="nsw-list-item__content-body">
          {(datestring || document) ? <div className="nsw-list-item__info">
            {datestring && <div className="nsw-list-item__date">
              <span className="material-icons">calendar_today</span>
              {' '+datestring}
            </div>}
            {document && <>
              <div className="nsw-list-item__file">
                <span className="material-icons">attach_file</span>
                {document.ext.toUpperCase()} {document.size}
              </div>
              <div className="nsw-list-item__download">
                <a href={document.url} className="nsw-button nsw-button--dark">
                  <span className="material-icons" focusable="false" aria-hidden="true">download</span>
                  <span>Download</span>
                </a>
              </div>
            </>}
          </div> : undefined}
          {(item.short_description || tags.length != 0) && <div className="nsw-list-item__copy">
            {item.short_description && (
              <p className="mt-2">{item.short_description}</p>
            )}
            {tags.length != 0 && <div className="nsw-list-item__tags">
              <ul>
                {tags.map(tag => <li key={tag.tid}>{tag.name}</li>)}
              </ul>
            </div>}
          </div>}
        </div> : undefined}
      </div>
    </div>)
  })
  return (
    <div className="space-y-4">
      {items}
    </div>
  );
};
